/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates the product certifications section
 *
 * Usage example:
 * <product-certifications
 *     data-product-certifications="ProductCtrl.productEfficiency">
 * </product-certifications>
 */
function productCertificationsDirective() {
    return {
        restrict: 'E',
        scope: {
            productCertifications: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: productCertificationsController,
        template: require('./productCertificationsView.html')
    };
}

productCertificationsController.$inject = [
    'CmsContentService'
];
function productCertificationsController (
    CmsContentService
) {

    this.$onInit = function () {
        var vm = this;
        // hide section if product does not have any certifications
        if (!vm.productCertifications.certifications || vm.productCertifications.certifications.length === 0) {
            vm.certificationsAvailable = false;
            return;
        }
        vm.certificationsAvailable = true;

        for (var i = 0; i < vm.productCertifications.certifications.length; i++) {
            var index = i;
            var cert = vm.productCertifications.certifications[i];
            CmsContentService.getMarketPlaceText(
                'details_page:certification',
                {
                    'category_name': vm.productCertifications.category.name,
                    'badge_text': cert.badge_text
                },
                vm.productCertifications.category.id
            ).then(function (text) { // jshint ignore:line
                vm.productCertifications.certifications[index].sentence = text;
            });
        }
    }
}

module.exports = productCertificationsDirective;
